export default () => ({
  apiSign: {},
  // 品牌升级通知条是否显示（供其它页面读取）
  brandUpgradeNoticeVisible: false,
})
